import { useAsync } from '@tiger/hooks';
import { Button } from 'antd';
import Card, { CardButtonWrap } from 'components/Card';
import ErrorBox from 'components/ErrorBox';
import Modal from 'components/Modal';
import { Loading } from 'components/Toast';
import store from '../../store';
import About from './components/About';
import AddContactModal from './components/AddContactModal';
import ContactPersonList from './components/ContactPersonList';
import Header from './components/Header';
import './style.scss';

const Trust: React.FC = () => {
    const [{ data, loading, error }, getContactPerson] = useAsync(() => store.getTrust());

    const { total = 0, items = [] } = data || {};

    const handleAddContact = () => {
        Modal.open({
            component: AddContactModal,
            className: 'trust-add-contact-modal-root',
            closable: true
        })
            .result.then(() => getContactPerson())
            .catch(() => {});
    };

    const renderMain = () => {
        if (loading) {
            return <Loading />;
        }

        if (error) {
            return <ErrorBox error={error} onClick={getContactPerson} />;
        }

        return (
            <>
                {total ? <ContactPersonList listData={items} getData={getContactPerson} /> : <About />}
                {total < 2 && (
                    <CardButtonWrap className="mt-5">
                        <Button onClick={handleAddContact} type="primary" size="large" className="btn-add">
                            {__(`Add New Contact`)}
                        </Button>
                    </CardButtonWrap>
                )}
            </>
        );
    };

    return (
        <Card>
            <div className="security-trust-root">
                <Header />
                {renderMain()}
            </div>
        </Card>
    );
};

export default Trust;
